import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/todo.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, CompleteTodoEvent } from './Types'
import { useHistory, generatePath } from 'react-router-dom'
import { DOC_PATH } from 'paths'

interface Props extends ActivityEventPosition {
  event: CompleteTodoEvent
}

const CompleteTodo = ({ event, ...props }: Props) => {
  const { user, data } = event
  const history = useHistory()

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    history.push({
      pathname: generatePath(DOC_PATH, { slug: event.article.slug }),
      search: `right_rail=Tasks&todosFilter=all&id=${data.todo_id}`,
    })
  }

  return (
    <BaseActivityEvent
      {...props}
      onClick={handleClick}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> resolved a task
        </>
      }
    />
  )
}

export { CompleteTodo }
